// @core/api/endpoints/booking/delete_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/booking';

/**
 * Delete bookable resource
 * Permanently deletes a bookable resource. Pause or retire the resource first if it has upcoming confirmed bookings.
 */
export async function DeleteResource(
  resource_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
